<template>
  <div>
    <div
      class="mb-0"
      v-if="showType == 'form-builder'"
      :style="properties.style"
    >
      <div class="d-flex justify-content-between bg-light-gray p-3">
        <h5 v-html-sanitize="properties.label"></h5>
        <div>
          <b-button variant="primary" class="mr-2"
            ><i class="fa fa-sync-alt mr-2"></i> Reload Patient Codes</b-button
          >
          <b-button variant="primary" hidden
            ><i class="fa fa-plus"></i
          ></b-button>
        </div>
      </div>
      <b-table
        striped
        responsive
        hover
        :items="[
          {
            code: 'Code 1',
            status: 'Status 1',
            activeFrom: 'Active From 1',
            resolvedBy: 'Resolved By 1',
            description: 'Description 1',
            action: 'Action 1'
          },
          {
            code: 'Code 2',
            status: 'Status 2',
            activeFrom: 'Active From 2',
            resolvedBy: 'Resolved By 2',
            description: 'Description 2',
            action: 'Action 2'
          }
        ]"
        :fields="fields"
      ></b-table>
    </div>
    <div v-if="showType == 'properties'">
      <eoc-diagnosis-codes-v1-properties :formId="formId" />
    </div>
    <div
      v-show="!computedHidden"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
    >
      <div
        class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2"
      >
        <div
          style="font-size: 16px"
          class="mb-0"
          v-html-sanitize="properties.label"
        ></div>
        <div>
          <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            @click="reloadPatientCodes"
            ><i class="fa fa-sync-alt mr-2"></i> Reload Patient Codes</b-button
          >
          <b-button size="sm" variant="primary" @click="addDiagnosisCode" hidden
            ><i class="fa fa-plus"></i
          ></b-button>
        </div>
      </div>
      <b-table
        striped
        responsive
        hover
        :items="Array.isArray(controlValue) ? controlValue : []"
        :fields="fields"
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === 'action' ? '80px' : null }"
          />
        </template>
        <template #thead-top=""> </template>
        <template #cell(status)="data">
          <div style="width: 110px">
            <span
              v-if="data.value"
              class="badge-v2 badge-warning px-4 py-2 text-white badge-fixed-size"
              :style="`background: ${data.value.color}`"
            >
              {{ data.value.name }}
            </span>
          </div>
        </template>
        <template #cell(activeFrom)="data">
          <div style="font-size: 14px">
            {{ data.value ? formatDateOnly(data.value) : "" }}
          </div>
        </template>
        <template #cell(resolvedBy)="data">
          <div style="font-size: 14px">
            {{ data.value ? formatDateOnly(data.value) : "" }}
          </div>
        </template>
        <template #cell(action)="row">
          <img
            class="b-action-item"
            @click="deleteCode(row.index)"
            src="/icons/delete.svg"
            width="16px"
            style="margin-left: 21px"
            hidden
          />
        </template>
      </b-table>
    </div>
    <div v-if="showType == 'form-viewer'" :style="properties.style">
      <div
        class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2"
      >
        <h5 class="mb-0" v-html-sanitize="properties.label"></h5>
      </div>
      <b-table striped responsive hover :items="controlValue" :fields="fields">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === 'action' ? '80px' : null }"
          />
        </template>
        <template #thead-top=""> </template>
        <template #cell(action)=""> </template>
      </b-table>
    </div>
    <b-modal
      centered
      ref="form-modal"
      title="Add Diagnosis Code"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitDiagnosisCode"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Cancel </b-button>
        <b-button variant="primary" @click="ok()"> Save </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="ICD-CODE*"
            :state="modalFormErrors.icdCodeId.length == 0 ? null : false"
            :invalid-feedback="modalFormErrors.icdCodeId.join(', ')"
          >
            <v-select
              class=""
              :class="
                icdCodes.length == 0 ? 'icd-code-picker-hide-options' : ''
              "
              placeholder="Search for ICD Codes"
              v-model="modalForm.icdCodeId"
              :options="icdCodes"
              @search="fetchIcdCodeOptions"
            >
              <template #no-options="{ search }">
                {{
                  search && search.length > 3
                    ? "Sorry, no matching options"
                    : ""
                }}
              </template>
              <template #open-indicator>
                <span></span>
              </template>
            </v-select>
            <div style="font-size: 10.5px; bottom: 0px; font-style: italic">
              This code will not be reflected in the patient's profile. If you
              want to modify the patient you can use the option "Icd Codes" in
              the form's right bar or go to the patient's profile.
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Status">
            <b-form-select
              placeholder=""
              v-model="modalForm.status"
              :options="statuses"
            />
          </b-form-group>
          <b-form-group
            label="Resolved by"
            v-if="showResolvedByInput"
            :state="modalFormErrors.resolvedBy.length == 0 ? null : false"
            :invalid-feedback="modalFormErrors.resolvedBy.join(', ')"
          >
            <date-picker
              v-model="modalForm.resolvedBy"
              :errors="modalFormErrors.resolvedBy"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Active From"
            :state="modalFormErrors.activeFrom.length == 0 ? null : false"
            :invalid-feedback="modalFormErrors.activeFrom.join(', ')"
          >
            <date-picker
              v-model="modalForm.activeFrom"
              :errors="modalFormErrors.activeFrom"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Comments">
            <b-form-textarea
              placeholder=""
              v-model="modalForm.comments"
              rows="6"
              max-rows="10"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import EocDiagnosisCodesV1Properties from "./EocDiagnosisCodesV1Properties.vue";
import icdCodeServer from "../../../../server/icdCode";
import { validateRequired, validateDate } from "../../../../helpers/validation";
import diagnosisCodeServer from "../../../../server/diagnosisCode";
import DatePicker from "../../../controls/DatePicker.vue";

export default {
  name: "EocDiagnosisCodesV1",
  components: { EocDiagnosisCodesV1Properties, DatePicker },
  props: [
    "showType",
    "properties",
    "form",
    "id",
    "formId",
    "results",
    "page",
    "componentsIdSuffix"
  ],
  data() {
    return {
      icdCodes: [],
      modalForm: {
        icdCodeId: null,
        status: "",
        activeFrom: "",
        resolvedBy: "",
        comments: ""
      },
      modalFormErrors: {
        icdCodeId: [],
        activeFrom: [],
        resolvedBy: []
      },
      initialCodes: [],
      computedProperties: ["hidden"],
      computedConditions: {}
    };
  },
  async mounted() {
    this.fetchDiagnosisCodeStatuses();
    if (
      this.showType != "form-builder" &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      const diagnosisCodes = await diagnosisCodeServer.query(
        false,
        this.client.episodeOfCare.id
      );
      this.initialCodes = diagnosisCodes.map((diagnosisCode) => {
        return {
          id: diagnosisCode.id,
          icdCode: diagnosisCode.icdCode.code,
          code: `${diagnosisCode.icdCode.code} - ${diagnosisCode.icdCode.description}`,
          description: diagnosisCode.description,
          status: diagnosisCode.status,
          resolvedBy: diagnosisCode.resolvedBy,
          activeFrom: diagnosisCode.activeFrom,
          category: diagnosisCode.category
        };
      });
      let prymaryCategory = this.initialCodes
        .filter((x) => x.category == "Primary")
        .sort((a, b) => a.icdCode.localeCompare(b.icdCode));
      let secundaryCategory = this.initialCodes
        .filter((x) => x.category == "Secondary")
        .sort((a, b) => a.icdCode.localeCompare(b.icdCode));
      let tertiaryCategory = this.initialCodes
        .filter((x) => x.category == "Tertiary")
        .sort((a, b) => a.icdCode.localeCompare(b.icdCode));
      this.initialCodes = [
        ...prymaryCategory,
        ...secundaryCategory,
        ...tertiaryCategory
      ];
      this.reloadPatientCodes();
      if (
        this.showType == "form-submitter" ||
        (this.showType == "e-form" && this.properties.eFormEditable)
      ) {
        this.setFormSubmitterComponentMetadata({
          controlId: this.id,
          controlMetadata: {
            label: this.properties.label
          }
        });
        if (this.componentsIdSuffix) {
          this.initializeComponentValue({
            controlId: this.id,
            properties: this.properties
          });
        }
      }
    }
    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", [
      "setFormSubmitterComponentValue",
      "initializeComponentValue"
    ]),
    ...mapActions("client", ["fetchDiagnosisCodeStatuses"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    deleteCode(rowIndex) {
      const newControlValue = [...this.controlValue];
      newControlValue.splice(rowIndex, 1);
      this.controlValue = newControlValue;
    },
    reloadPatientCodes() {
      this.controlValue = this.initialCodes;
    },
    async fetchIcdCodeOptions(search, loading) {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      if (search && search.trim().length >= 3) {
        this.icdCodes = [];
      }

      this.lastTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const icdCodes = await icdCodeServer.query(
            { searchPhrase: search },
            {
              "Hide-Loading": true
            }
          );
          this.icdCodes = icdCodes.map((icdCode) => ({
            value: icdCode.id,
            label: `${icdCode.code} - ${icdCode.description}`,
            data: icdCode
          }));
        } else this.icdCodes = [];
        loading(false);
      }, 1000);
    },
    validateDiagnosisCodeSubmit() {
      let withoutErrors = true;

      this.modalFormErrors.icdCodeId = [];
      if (!validateRequired(this.modalForm.icdCodeId)) {
        this.modalFormErrors.icdCodeId.push("This field is required");
        withoutErrors = false;
      }

      this.modalFormErrors.activeFrom = [];
      if (
        this.modalForm.activeFrom &&
        !validateDate(this.modalForm.activeFrom)
      ) {
        this.modalFormErrors.activeFrom.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      this.modalFormErrors.resolvedBy = [];
      if (
        this.showResolvedByInput &&
        this.modalForm.resolvedBy &&
        !validateDate(this.modalForm.resolvedBy)
      ) {
        this.modalFormErrors.resolvedBy.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitDiagnosisCode(modalEvent) {
      const result = this.validateDiagnosisCodeSubmit();
      if (result) {
        const newControlValue = [...this.controlValue];
        const status = this.statuses.find(
          (u) => u.value == this.modalForm.status
        );
        newControlValue.push({
          code: `${this.modalForm.icdCodeId.data.code} - ${this.modalForm.icdCodeId.data.description}`,
          status: status.data,
          activeFrom: this.modalForm.activeFrom,
          resolvedBy: this.modalForm.resolvedBy,
          description: this.modalForm.comments
        });
        this.controlValue = newControlValue;
      } else modalEvent.preventDefault();
    },
    addDiagnosisCode() {
      this.modalForm = {
        icdCodeId: null,
        status: "",
        activeFrom: "",
        resolvedBy: "",
        comments: ""
      };
      this.modalFormErrors = {
        icdCodeId: [],
        activeFrom: [],
        resolvedBy: []
      };
      this.$refs["form-modal"].show();
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <div>
        <div class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2">
          <div style="font-size:16px;" class="mb-0">${this.getComponentComputedProperties(
            "label"
          )}</div>
        </div>
        <table role="table" aria-busy="false" aria-colcount="2" class="table b-table table-striped table-responsive table-hover">
          <thead role="colgroup">
            <tr role="row">
              <th role="columnheader" scope="col" aria-colindex="1">
                <div>Code</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="2">
                <div style="width: 120px;">Status</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="3">
                <div style="width: 120px;">Active From</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="4">
                <div style="width: 120px;">Resolved By</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="5">
                <div style="width: 130px;">Comments</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="6">
                <div style="width: 60px;">Action</div>
              </th>
            </tr>
          </thead>
          <tbody role="rowgroup">
              ${(this.controlValue || [])
                .map(
                  (item) => `
              <tr role="row" class="">
                <td style="font-size:14px" aria-colindex="1" role="cell" class="">${
                  item.code
                }</td>
                <td style="font-size:14px" aria-colindex="2" role="cell" class="">
                  ${
                    item.status
                      ? `<span class="badge-v2 badge-warning px-4 py-2 text-white badge-fixed-size" style="background: ${item.status.color}; white-space: nowrap;">
                    ${item.status.name}
                  </span>`
                      : ""
                  }                  
                </td>
                <td style="font-size:14px" aria-colindex="3" role="cell" class="">${
                  item.activeFrom ? this.formatDateOnly(item.activeFrom) : ""
                }</td>
                <td style="font-size:14px" aria-colindex="4" role="cell" class="">${
                  item.resolvedBy ? this.formatDateOnly(item.resolvedBy) : ""
                }</td>
                <td style="font-size:14px" aria-colindex="5" role="cell" class="">${
                  item.description ? item.description : ""
                }</td>
                <td style="font-size:14px" aria-colindex="6" role="cell" class=""></td>
              </tr>
            `
                )
                .join("")}
          </tbody>
        </table>
      </div>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage
    }),
    ...mapState("client", {
      statuses: (state) =>
        state.diagnosisCodeStatuses.map((diagnosisCodeStatus) => ({
          value: diagnosisCodeStatus.id,
          text: diagnosisCodeStatus.name,
          data: diagnosisCodeStatus
        }))
    }),
    computedPropertiesForm() {
      return (
        this.$store.state.formSubmitter.form.computedProperties[this.id] ??
        this.properties
      );
    },
    showResolvedByInput() {
      return (
        this.modalForm.status &&
        this.modalForm.status ==
          this.statuses.find((u) => u.text === "Resolved").value
      );
    },
    fields() {
      return [
        {
          key: "code",
          label: "Code",
          sortable: false,
          class: "fixed-width-code"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "fixed-width"
        },
        {
          key: "activeFrom",
          label: "Active From",
          sortable: false,
          class: "fixed-width"
        },
        {
          key: "resolvedBy",
          label: "Resolved By",
          sortable: false,
          class: "fixed-width"
        },
        {
          key: "description",
          label: "Comments",
          sortable: false
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ];
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden;

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style>
.icd-code-picker-hide-options .vs__dropdown-menu {
  display: none;
}
.icd-code-picker-hide-options.vs--open .vs__dropdown-toggle {
  border-bottom-color: #4044e6 !important;
  border-bottom-width: 2px;
}
.without-thead thead {
  display: none;
}
.without-thead th,
.without-thead td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.without-thead td:nth-child(1) {
  font-size: 12px;
  padding-left: 17px;
}
.without-thead td:nth-child(2) {
  padding: 0px;
}
.fixed-width {
  width: 120px;
}
.fixed-width-code {
  width: 200px;
}
</style>
